<template>
  <div>
    <Head title="Purchase Orders" />
    <div class="flex items-center justify-between">
      <h1 class="text-3xl font-bold">Purchase Orders</h1>

      <Link class="btn-indigo" href="/purchaseorders/create" v-if="(auth.user.role == 'ADMIN')" >
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;PO</span>
      </Link>
    </div>
    <div class="flex items-center justify-between mb-3">
      <!--<search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>-->
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-3">#</th>
            <th class="pb-4 pt-6 px-6">Site Name</th>
            <th class="pb-4 pt-6 px-6">PO Date</th>
            <th class="pb-4 pt-6 px-6">PO Type</th>
            <th class="pb-4 pt-6 px-6">Building</th>
            <th class="pb-4 pt-6 px-6">Floor</th>
            <th class="pb-4 pt-6 px-6">Vendor/Bid</th>
            <th class="pb-4 pt-6 px-6"></th>
            
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in jobsiteorders" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <template v-if="((auth.user.vendor == order.vendor) || (auth.user.vendor == 0))">
            <td class="border-t">
              <Link class="flex items-center px-3 py-4 focus:text-indigo-500" :href="`/purchaseorders/${order.id}/edit`">
                {{ pad(order.id) }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/purchaseorders/${order.id}/edit`">
                {{ getJobsiteName(order.jobsite_id) }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/purchaseorders/${order.id}/edit`" tabindex="-1">
                {{ moment(order.order_date).format('MM/DD/YYYY') }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/purchaseorders/${order.id}/edit`" tabindex="-1">
                {{ order.ordertype }}
              </Link>
            </td>

            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/purchaseorders/${order.id}/edit`" tabindex="-1">
                {{ (order.ordertype == 'TRUSS') ? (order.building) : '' }}
              </Link>
            </td>

            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/purchaseorders/${order.id}/edit`" tabindex="-1">
                {{ (order.ordertype == 'TRUSS') ? (order.floor) : '' }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/purchaseorders/${order.id}/edit`" tabindex="-1">
                {{ getVendorName(order.vendor) }} {{ order.bid_id }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/purchaseorders/${order.id}/edit`" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
           </template>
          </tr>
          <tr v-if="purchaseorders.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No POs found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--<pagination class="mt-6" :links="purchaseorders.links" />-->
  </div>
  <div id="updatejobsite" @click="filterOrders(this.purchaseorders)" @onload="flterOrders(this.purchaseorders)"></div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import moment from 'moment'

export default {
  mounted() {
    this.filterOrders(this.purchaseorders);
  },
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    purchaseorders: Object,
    jobsites: Object,
    auth: Object,
    vendors: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      moment: moment,
      filteredjobsites: this.authjobsites(),
      jobsiteorders: [],
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/purchaseorders', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    filterOrders() {
      var jsid = document.querySelector('#jobsiteselector').value;
      var ordersyes = [];
      this.purchaseorders.data.forEach((ord) => {
        if (parseInt(ord.jobsite_id) == parseInt(jsid)) {
          ordersyes.push(ord);
        }
      });
      this.jobsiteorders = ordersyes;
    },
    getVendorName(vid) {
      var vn = '';
      this.vendors.data.forEach((v,k) => {
        if (vid == v.id) { vn = v.vendorname; }
        //console.log(vid + '--' + v.id);
      });
      return vn;
    },
    authjobsites() {
      var jsa = JSON.parse(this.auth.user.jobsiteaccess);
      var jobsitesyes = [];
      this.jobsites.data.forEach((js) => {
        if (jsa[js.id] == 1) {
          jobsitesyes.push(js);
        }
      });
      return jobsitesyes;
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    getJobsiteName(order_jobsite_id) {
      var jsn = '';
      this.jobsites.data.forEach((jobsite) => {
        if (jobsite.id == order_jobsite_id) { jsn = jobsite.sitename; }
      })
      return jsn;
    },
    formatdate(dv) {
      if (dv) {
        return moment(dv).format('MM/DD/YYYY');
      } else { return ""; }
    },
    pad(n) {
      return n.toString().padStart(5,"0");
    },
  },
}
</script>
